import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

/**
 * About Talas Trading Company.
 *
 * Copy on this page is final and approved — do not alter. The two disclaimer lines
 * that used to live on the homepage now sit at the bottom of this page.
 */
export default function About() {
  return (
    <div className="min-h-screen bg-[#0A0A0B] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <section className="relative overflow-hidden">
          <div className="absolute -top-40 -left-40 w-[480px] h-[480px] rounded-full bg-[#C9A24B]/[0.06] blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl mx-auto px-5 sm:px-6 lg:px-12 pt-16 lg:pt-24 pb-16">
            <div className="flex items-center gap-3 fade-in-up">
              <span className="h-px w-12 bg-[#C9A24B]" />
              <p className="text-[10px] tracking-[0.4em] font-mono gold-text uppercase">About</p>
            </div>

            <h1 className="font-display mt-6 text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F1ECDF] leading-[1.05] fade-in-up" style={{ animationDelay: '0.05s' }}>
              About Talas <span className="gold-text">Trading Company</span>
            </h1>

            <div className="mt-10 space-y-6 text-[15px] sm:text-base text-[#CDBE94] leading-relaxed fade-in-up" style={{ animationDelay: '0.1s' }} data-testid="about-body">
              <p>
                Talas Trading Company was built from nearly two years of nonstop development, testing, rebuilding, and refining one clear idea: make advanced trading automation accessible to everyday people.
              </p>
              <p>
                What started as a personal mission to build a smarter trading system has grown into a full automation platform designed around AI-driven market scanning, hands-free trade execution, live dashboards, user account connections, signal tracking, risk controls, and continuous strategy improvement. Talas was not created as a one-time bot or a quick trading script. It has been built as a real technology company focused on automation, data, strategy development, and long-term innovation.
              </p>
              <p>
                Over the last two years, we have tested and developed systems across stocks, options, and futures, while building the tools needed to support real users: account dashboards, broker connections, paper trading access, live signal monitoring, automated execution, trade logs, user management, subscription systems, and ongoing backend infrastructure. Every part of Talas has been shaped through real testing, real market conditions, and constant improvement.
              </p>
              <p>
                Our goal is simple: give people access to trading technology that normally feels out of reach. Whether someone is a beginner who wants to see how automated trading works, a busy person who does not have time to watch charts all day, or an experienced trader looking for AI-powered tools, Talas is being built to make trading automation easier to understand, easier to access, and easier to use.
              </p>
              <p>
                Talas Trading Company is focused on building a serious automation service, not a hype project. We are continuously monitoring, upgrading, testing, and expanding the platform with the goal of becoming a trusted name in AI-assisted trading tools, strategy automation, licensing, and custom trading technology.
              </p>
              <p>
                This is only the beginning. Talas has been built through two years of work, belief, late nights, testing, failures, breakthroughs, and relentless improvement — and now we are bringing it to the people.
              </p>
            </div>

            {/* Disclaimers — moved here from the homepage. Small, in dim warm gold. */}
            <div className="mt-14 pt-8 border-t border-[rgba(201,162,75,0.16)] space-y-2" data-testid="about-disclaimers">
              <p className="text-xs leading-relaxed" style={{ color: '#A99563' }}>
                Talas beta uses Alpaca paper trading only. No live funds are used during beta.
              </p>
              <p className="text-xs leading-relaxed" style={{ color: '#A99563' }}>
                Trading involves substantial risk. Automation does not guarantee profits or prevent losses.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
